export default async function getUserPushSubscription() {
  let serviceWorkerRegistration = await navigator.serviceWorker.getRegistration();
  let potentialRegistration = await serviceWorkerRegistration.pushManager.getSubscription();
  return potentialRegistration;
}
